import Button from 'components/_UI/Button'
import Modal from 'components/_UI/Modal'
import Text from 'components/_UI/Text'
import React from 'react'
import buttonText from 'texts/buttons/buttonText'
import colors from 'theme/colors'

export default function ExpirationModal({ visible, onBack }) {
    return (
        <Modal isOpen={visible} closeButton={false}>
            <Text name='highlight' color={colors.nightDark}>
                Seu tempo de compra expirou
            </Text>

            <Text marginTop={'10px'} textAlign={'center'}>
                Isso acontece pois precisamos assegurar que os ingressos/produtos fiquem disponíveis para aquisição, considerando que existe um número limitado para venda.
            </Text>

            <Text type='bold' textAlign={'center'}>
                Caso você queira realizar a compra, clique em voltar. O tempo para finalizar o processo da compra é de 20 minutos.
            </Text>

            <Button
                marginTop={'10px'}
                variant={'lightBlue'}
                onClick={onBack}
            >
                {buttonText.back}
            </Button>
        </Modal>
    )
}
